module.exports = __webpack_public_path__ + "static/media/animated-triangles--white.571e7089.gif";